import Vue from 'vue';
import axios from 'axios';

import store from './store/index';
import Echo from './services/echo';
import Game from './components/Game';

axios.interceptors.request.use(function (config) {
  if (store.state.user.api_token) {
    config.headers.Authorization = 'Bearer ' + store.state.user.api_token;
  }

  config.headers['X-Socket-ID'] = Echo.socketId();

  return config;
});

if (document.getElementById('app')) {
  new Vue({
    el: '#app',
    components: {Game},
    store
  });
}
